import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { ProgressStepperStep } from '@domgen/dgx-fe-components/progress';
import { BehaviorSubject, Observable } from 'rxjs';
import { Theme } from '@domgen/dgx-fe-common';
import { SmartFixCustomProgressStepperItemComponent } from './progress-stepper-item/progress-stepper-item.component';
import { FeedbackComponent } from '../feedback/feedback.component';
import { CONFIG, ENVIRONMENT } from '@domgen/dgx-fe-config';
import { AppConfig } from 'apps/dg-self-fix/src/app/models/config/app-config.type';
import { ButtonLinkComponent } from '@domgen/dgx-fe-components/button';
import { SmartFixHubAnalyticsService } from 'libs/self-fix/data-access/src/lib/services/sf-hub-analytics/sf-hub-analytics-service';
import { Router } from '@angular/router';
import { RedirectToMMRComponent } from '../redirect-to-mmr/redirect-to-mmr.component';
import { AppEnvironment } from 'apps/dg-self-fix/src/app/models/environment/app-environment.type';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    SmartFixCustomProgressStepperItemComponent,
    FeedbackComponent,
    RedirectToMMRComponent,
    ButtonLinkComponent,
  ],
  selector: 'progress-stepper-smart-fix-hub',
  templateUrl: './progress-stepper.component.html',
  styleUrls: ['./progress-stepper.component.scss'],
})
@SeoPage()
export class SmartFixCustomProgressStepperComponent implements OnInit {
  @Input() content!: CmsArea;

  constructor(
    @Inject(CONFIG) private readonly config: AppConfig,
    @Inject(ENVIRONMENT) public environment: AppEnvironment,
    private readonly smartFixAnalytics: SmartFixHubAnalyticsService,
    private readonly router: Router
  ) {}
  formattedSteps: ProgressStepperStep[] = [];

  @Input() startPage = false;
  @Input() set steps(steps: ProgressStepperStep[]) {
    this.progressStepsSubject.next(steps);
    this.progressStepsLength = steps.length;
  }
  @Input() title = '';
  @Input() theme: Theme = 'background';
  planNumber: string | null = '';

  private readonly progressStepsSubject = new BehaviorSubject<
    ProgressStepperStep[]
  >([]);
  progressSteps$: Observable<ProgressStepperStep[]> = this.progressStepsSubject;
  progressStepsLength = 0;

  currentIndex = 0;
  dropShadow = true;
  articleTitle = this.router.url.split('/').pop();

  ngOnInit(): void {
    this.smartFixAnalytics.trackEvent({
      pagename: `claims-sf-hub-article-starts-${this.articleTitle}`,
      event: 'spa-pageview',
    });
  }

  ngAfterContentInit(): void {
    const value = this.progressStepsSubject.value ?? [];
    this.progressStepsLength = value.length;
  }

  ngOnChanges(): void {
    this.dropShadow = !this.startPage;
  }

  previous(): void {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1;
    }
    if (this.startPage && this.currentIndex == 0) {
      this.dropShadow = false;
    }
  }

  next(): void {
    this.progressSteps$.subscribe((steps) => {
      if (this.currentIndex === 0 && this.startPage) {
        this.smartFixAnalytics.trackEvent({
          eventCategory: 'sf-hub',
          eventAction: 'article-starts',
          eventLabel: "Let's start",
          pagename: 'claims-sf-hub-article-lets-start',
          event: 'genericGAEvent',
        });
      }

      if (this.currentIndex < steps.length - 1) {
        this.currentIndex += 1;
        this.dropShadow = true;

        if (this.currentIndex === steps.length - 1) {
          this.smartFixAnalytics.trackEvent({
            event: 'spa-pageview',
            pagename: `claims-sf-hub-article-last-step-${this.articleTitle}`,
          });
        }
      }
    });
  }

  trackByStepIndex(index: number): number {
    return index;
  }
}
